<div class="modal-body">
  <div class="content">
    <div class="content__top">
      <h4 translate>numbers.popups.full-info.title</h4>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <i class="icon-small-close" aria-hidden="true"></i>
      </button>
    </div>
    <div class="content__main">
      <div class="did-info">
        <h5 translate>numbers.popups.full-info.did-data.title</h5>
        <div class="did-info__table">
          <table>
            <tbody>
              <tr>
                <td translate>
                  numbers.table.thead.number.label
                </td>
                <td>
                  <span><span class="flag-icon flag-icon-{{did.country | lowercase}}"></span>{{did.number}}</span>
                </td>
              </tr>
              <tr>
                <td translate>
                  numbers.table.thead.status.label
                </td>
                <td>
                  <gdp-did-status [status]="did.status"></gdp-did-status>
                </td>
              </tr>
              <tr>
                <td translate>
                  numbers.table.thead.company-id.label
                </td>
                <td>
                  {{did.company_id}}
                </td>
              </tr>
              <tr>
                <td translate>
                  numbers.table.thead.type.label
                </td>
                <td>
                  <div class="types">
                    <div class="types__type">
                      <gdp-number-type [type]="did.did_type"></gdp-number-type>
                    </div>
                    <div class="types__temporary">
                      <gdp-number-temporary-status [temporaryStatus]="did.is_from_pool"></gdp-number-temporary-status>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td translate>
                  numbers.table.thead.class.label
                </td>
                <td>
                  {{did.did_class}}
                </td>
              </tr>
              <tr>
                <td translate>
                  numbers.table.thead.provider.label
                </td>
                <td>
                  {{did.provider}}
                </td>
              </tr>
              <tr>
                <td translate>
                  numbers.table.thead.creation.label
                </td>
                <td>
                  <div class="dates">
                    <span [ngbTooltip]="did.creation_date | date:'medium': undefined: locale">
                      {{did.creation_date | date: 'dd.MM.yyyy'}}
                      <i class="icon-small-info"></i>
                    </span>
                    <i class="dates__separator">/</i>
                    <span [ngbTooltip]="did.allocation_date | date:'medium': undefined: locale">
                      {{did.allocation_date | date: 'dd.MM.yyyy'}}
                      <i class="icon-small-info"></i>
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="verification-data">
        <h5 translate>numbers.popups.full-info.verification-data.title</h5>
        <vox-vd-table-readonly [data]="verificationData" [language]="currentLang" [loading]="loading">
        </vox-vd-table-readonly>
      </div>
    </div>
  </div>
</div>